export function createImsSubmission(lead_id) {
	console.log('Creating IMS submission/quote for lead:', lead_id);

	// Hide button to prevent multiple clicks
	$('.submit_api_ims').hide();

	// Show a "please wait" message
	const $loadingMessage = $('<div class="loading-message">Creating quote in IMS, please wait...</div>').css({
		'position': 'relative',
		'color': '#555',
		'border': '1px solid #aaa',
		'padding': '4px 10px',
		'margin-top': '10px',
		'background-color': '#f9f9f9',
		'border-radius': '4px',
	});
	$('.submit_api_ims_wrap').append($loadingMessage);

	// AJAX call
	$.ajax({
		type: 'POST',
		url: '/Ims_export/create_quote',
		data: { lead_id: lead_id },
		dataType: 'json',
		success: function (resp) {
			// Remove the "please wait" message now that we have a response
			$loadingMessage.remove();

			if (resp.error) {
				// Show an error message in red
				const $errorMessage = $(`
          <div class="error-message">Error creating IMS Quote: ${resp.error}</div>
        `).css({
					'position': 'relative',
					'color': 'red',
					'border': '1px solid red',
					'padding': '4px 10px',
					'margin-top': '10px',
					'background-color': '#ffe6e6',
					'border-radius': '4px',
				});
				$('.submit_api_ims_wrap').prepend($errorMessage);

				// Optionally let the user try again
				$('.submit_api_ims').show();
			} else {
				// Success message in green
				const controlNo = resp.control_no || 'N/A';
				const $successMessage = $(`
          <div class="success-message">IMS Quote created successfully! Control No: ${controlNo}</div>
        `).css({
					'position': 'relative',
					'color': 'green',
					'border': '1px solid green',
					'padding': '4px 10px',
					'margin-top': '10px',
					'background-color': '#e6ffe6',
					'border-radius': '4px',
				});

				// Insert message, then fade out
				$successMessage.prependTo('.submit_api_ims_wrap')
					.delay(3000)    // visible for 3 seconds
					.fadeOut(1000); // fade out over 1 second

				location.reload();
			}
		},
		error: function () {
			// Remove loader
			$loadingMessage.remove();

			// Show a generic error
			const $errorMessage = $(`
        <div class="error-message">Error contacting IMS. Please try again later.</div>
      `).css({
				'position': 'relative',
				'color': 'red',
				'border': '1px solid red',
				'padding': '4px 10px',
				'margin-top': '10px',
				'background-color': '#ffe6e6',
				'border-radius': '4px',
			});
			$('.submit_api_ims_wrap').prepend($errorMessage);

			// Optionally let user retry
			$('.submit_api_ims').show();
		}
	});
}

export function initControlNoCheck(data) {
	// If 'data' is null or undefined, bail out to avoid errors.
	if (!data) {
		console.warn('initControlNoCheck was called, but no data object was provided.');
		return;
	}

	// Safely handle 'last_control_number'
	if (data.last_control_number) {
		// We have a control number, so hide the submit button
		$('.submit_api_ims').hide();

		// Optional: handle date/time if you have it (e.g. data.last_ims_submitted_date)
		let submittedText = '';
		if (data.last_ims_submitted_date) {
			submittedText = `Submitted to IMS on: ${data.last_ims_submitted_date}<br>`;
		}

		// Display the control number
		$('.submit_api_ims_wrap').html(`
      <span class="cn_wrpa">
        ${submittedText}
        IMS Control #: ${data.last_control_number}
      </span>
    `);
		$('#ims_control_number').val(data.last_control_number);
	} else {
		// Clear any old label and show the submit button
		$('.submit_api_ims_wrap .cn_wrpa').remove();
		$('.submit_api_ims').show();
	}
}


// Global event binding (only runs once)
let initIMSButtonsGlobalEvents = () => {
	initIMSButtonsGlobalEvents = null; // run only once

	// 1) For each email's "Email to IMS" button
	$(document).on('click', '.submit_email_only', function () {
		const $btn = $(this);
		const emailId = $btn.data('email_id'); // read from data-email_id attribute

		// Disable the button and show a quick message:
		$btn.prop('disabled', true).text('Sending...');
		sendEmailToIMS(emailId, $btn);
	});

	// 2) For "CABReport to IMS" button
	$(document).on('click', '.submit_cabreport_ims', function () {
		const $btn = $(this);
		// Retrieve lead_id from a DOM element (for example, an input with id "lead_id")
		const leadId = $('#lead_id').val();

		// Disable the button and show a quick message:
		$btn.prop('disabled', true).text('Sending...');
		sendCabReportToIMS(leadId, $btn);
	});
};


/**
 * export_to_ims.js
 *
 * Existing code for createImsSubmission() and initControlNoCheck() omitted for brevity;
 * you can keep them exactly as they are. Below we add new functions for:
 *
 *   - sendEmailToIMS()
 *   - sendCabReportToIMS()
 *
 * and an initialization function that wires up click handlers for the new buttons.
 */

/**
 * Attaches click handlers to the new "Email to IMS" and "CABReport to IMS" buttons.
 * @param {number} leadId The current lead ID you want to pass to the controller.
 */
export function initIMSButtons(leadData) {
	let lead_id = $('#lead_id').val();

	initIMSButtonsGlobalEvents?.();



	// 3) If leadData.lead_ims_docs has a doc with "CABReport" in filename, we hide the button or show a message
	if (Array.isArray(leadData.lead_ims_docs) && leadData.lead_ims_docs.length > 0) {
		const cabDoc = leadData.lead_ims_docs.find(doc => doc.filename && doc.filename.includes('CABReport'));
		if (cabDoc) {
			// We have a doc => hide or replace the .submit_cabreport_ims button
			let formattedTime = formatIMSDateTime(cabDoc.added);
			// Replace the entire container so user sees "CAB already sent"
			$('.submit_cabreport_ims_wrap').empty();
			$('.submit_cabreport_ims_wrap').html(`
        <div class="already-sent-cab">
          CAB Report already sent to IMS on:<br>
          ${formattedTime}
        </div>
      `);
		}else {
			$('.submit_cabreport_ims_wrap').html(`
        <button class="btn submit_api submit_cabreport_ims ">CABReport to IMS</button>
      `);

		}
	}else {
		$('.submit_cabreport_ims_wrap').html(`
        <button class="btn submit_api submit_cabreport_ims ">CABReport to IMS</button>
      `);

	}


}
// A tiny helper to format your date/time nicely
function formatIMSDateTime(isoString) {
	// Convert "YYYY-MM-DD HH:MM:SS" into a proper Date object
	const [datePart, timePart] = isoString.split(' ');
	const [year, month, day] = datePart.split('-');
	const [hour, minute, second] = timePart.split(':');

	// Build a JS Date object
	const dt = new Date(year, month - 1, day, hour, minute, second);

	// e.g. using toLocaleString to get "1/19/2025, 9:19:00 PM"
	// Then do additional parsing if you want to drop seconds, etc.
	const options = {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
		hour: 'numeric',
		minute: '2-digit',
		hour12: true,
	};
	return dt.toLocaleString([], options).replace(',', ' at');
	// e.g. "01/19/2025 at 9:19 PM"
}

/**
 * Sends a single email (by emailId) to IMS.
 * Calls /Ims_export/sendEmailToIMSQuote?lead_id=XXX&email_id=YYY (or via POST).
 *
 * @param {number} leadId
 * @param {number} emailId
 * @param {jQuery} $btn The button so we can re-enable or show messages near it
 */
function sendEmailToIMS(emailId, $btn) {
	// If you prefer a "please wait" message in the same container:
	const $wrap = $btn.closest('.submit_email_only_wrap');
	const $loadingMsg = $('<div class="loading-message">Sending email to IMS, please wait...</div>');
	$wrap.append($loadingMsg);

	$.ajax({
		type: 'POST',
		url: '/Ims_export/send_single_email_to_ims',
		data: { email_id: emailId },
		dataType: 'json',
		success: function (resp) {
			$loadingMsg.remove();

			// We rely on `resp.status` (true/false).
			if (resp.status === true) {
				// Success
				const $success = $(`
          <div class="success-message" style="color:green; border:1px solid green; padding:4px; margin-top:5px;">
            Email sent to IMS successfully! 
            <br> Server says: ${resp.log}
          </div>
        `);
				$wrap.append($success);

				// Optionally: remove the button, or set docGuid in your data model
				$btn.remove();

				// If you store docGuid or "ims_added" in the DB, you might update the DOM
				// so next time we see "Already Sent" instead of the button. E.g.:
				// $wrap.after(`<div class="already-sent-ims">Email sent to IMS just now</div>`);
			} else {
				// Failure
				const $error = $(`
          <div class="error-message" style="color:red; border:1px solid red; padding:4px; margin-top:5px;">
            Error: ${resp.log || 'Unknown error'}
          </div>
        `);
				$wrap.append($error);

				// Re-enable button
				$btn.prop('disabled', false).text('Email to IMS');
			}
		},
		error: function () {

			$loadingMsg.remove();
			const $error = $(`
        <div class="error-message" style="color:red; border:1px solid red; padding:4px; margin-top:5px;">
          Error contacting server. Please try again later.
        </div>
      `);
			$wrap.append($error);
			$btn.prop('disabled', false).text('Email to IMS');
		}

	});
}

/**
 * Sends the CABReport to IMS for the given lead.
 * Calls /Ims_export/sendCABToIMS?lead_id=XXX (or via POST).
 *
 * @param {number} leadId
 * @param {jQuery} $btn The button so we can re-enable or show messages near it
 */
function sendCabReportToIMS(leadId, $btn) {
	const $wrap = $btn.closest('.submit_cabreport_ims_wrap');
	const $loadingMsg = $('<div class="loading-message">Sending CAB Report to IMS, ETA 1min - please wait...</div>');
	$wrap.append($loadingMsg);

	$.ajax({
		type: 'POST',
		url: '/Ims_export/send_cab_report_to_ims',
		data: { lead_id: leadId },
		dataType: 'json',
		success: function (resp) {
			$loadingMsg.remove();

			if (!resp.status) {
				// Failure branch using the log as error message
				const $error = $(`
                    <div class="error-message" style="color:red; border:1px solid red; padding:4px; margin-top:5px;">
                        Error sending CAB Report to IMS: ${resp.log}
                    </div>
                `);
				$wrap.append($error);
				$btn.prop('disabled', false).text('CABReport to IMS');
			} else {
				// Success branch
				const $success = $(`
                    <div class="success-message" style="color:green; border:1px solid green; padding:4px; margin-top:5px;">
                        CAB Report uploaded to IMS successfully!
                    </div>
                `);
				$wrap.append($success);
				// Optionally hide or remove the button
				// $btn.hide();
			}
		},
		error: function () {
			$loadingMsg.remove();
			const $error = $(`
                <div class="error-message" style="color:red; border:1px solid red; padding:4px; margin-top:5px;">
                    Error contacting server. Please try again later.
                </div>
            `);
			$wrap.append($error);
			$btn.prop('disabled', false).text('CABReport to IMS');
		}
	});
}
